const translations = {
    fr: 
        {
            accueil: 'Accueil',
            sommaire: 'Sommaire',
            nouveaute: 'Nouveautés'
        },
    uk: 
        {
            accueil: 'Home',
            sommaire: 'Summary',
            nouveaute: 'News'
        },
    de: 
        {
            accueil: 'Startseite',
            sommaire: 'Inhaltsverzeichnis',
            nouveaute: 'Neuigkeiten'
        },
    es: 
        {
            accueil: 'Inicio',
            sommaire: 'Resumen',
            nouveaute: 'Novedades'
        }
}

export default translations;